import { IconProps } from './types';

const PersonWithSeperatorIcon = (props: IconProps) => {
  const { width = '16', height = '16', fillColor = '#0276FE' } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
    >
      <mask
        id="mask0_353_7506"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width={width}
        height={height}
      >
        <rect width={width} height={height} fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_353_7506)">
        <path
          d="M8.00033 8.00008C7.26699 8.00008 6.63921 7.73897 6.11699 7.21675C5.59477 6.69453 5.33366 6.06675 5.33366 5.33341C5.33366 4.60008 5.59477 3.9723 6.11699 3.45008C6.63921 2.92786 7.26699 2.66675 8.00033 2.66675C8.73366 2.66675 9.36144 2.92786 9.88366 3.45008C10.4059 3.9723 10.667 4.60008 10.667 5.33341C10.667 6.06675 10.4059 6.69453 9.88366 7.21675C9.36144 7.73897 8.73366 8.00008 8.00033 8.00008ZM2.66699 12.0001V11.4667C2.66699 11.089 2.76421 10.7417 2.95866 10.4251C3.1531 10.1084 3.41144 9.86675 3.73366 9.70008C4.42255 9.35564 5.12255 9.0973 5.83366 8.92508C6.54477 8.75286 7.26699 8.66675 8.00033 8.66675C8.73366 8.66675 9.45588 8.75286 10.167 8.92508C10.8781 9.0973 11.5781 9.35564 12.267 9.70008C12.5892 9.86675 12.8475 10.1084 13.042 10.4251C13.2364 10.7417 13.3337 11.089 13.3337 11.4667V12.0001C13.3337 12.3667 13.2031 12.6806 12.942 12.9417C12.6809 13.2029 12.367 13.3334 12.0003 13.3334H4.00033C3.63366 13.3334 3.31977 13.2029 3.05866 12.9417C2.79755 12.6806 2.66699 12.3667 2.66699 12.0001Z"
          fill={fillColor}
        />
      </g>
    </svg>
  );
};

export default PersonWithSeperatorIcon;
